import React, { Component } from 'react';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from '../site/PlotStatus';
export default class PlotsMenuEntry {
	constructor({siteJsonUnitPlot, callbackClicked, configuration}){
		this._callbackClicked = callbackClicked;
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._handleClicked= this._handleClicked.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('plots-menu-entry');
		this._imageWrapperElement = document.createElement('div');
		this._imageWrapperElement.classList.add("image-wrapper");
		this._img = document.createElement('img');
		this._img.classList.add('image');
		this._img.src = `${Urls.getAssetsForSite(configuration.siteSlug)}${UrlHelper.removeStartSlash(siteJsonUnitPlot.frontViewImage.getBestEntryToFitHeight(50).relativePath)}`;
		this._descriptionWrapperElement = document.createElement('div');
		this._descriptionWrapperElement.classList.add('description-wrapper');
		this._descriptionElement = document.createElement('div');
		const blockString = siteJsonUnitPlot.unit.plots.length>1?`Block ${siteJsonUnitPlot.unit.id}`:'';
		this._descriptionElement.innerHTML = `<span class="number">${blockString} Plot ${siteJsonUnitPlot.number}</span>&nbsp;${siteJsonUnitPlot.name}`;
		this._plotStatusElement = document.createElement('div');
		this._plotStatusElement.classList.add('plot-status');
		this._plotStatusElement.classList.add(PlotStatus.getCssName(siteJsonUnitPlot.status));
		this._plotStatusElement.innerHTML = `${PlotStatus.getDescription(siteJsonUnitPlot.status)}`;
		this._element.appendChild(this._imageWrapperElement);
		this._imageWrapperElement.appendChild(this._img);
		this._element.appendChild(this._descriptionWrapperElement);
		this._descriptionWrapperElement.appendChild(this._descriptionElement);
		this._descriptionWrapperElement.appendChild(this._plotStatusElement);
		this._element.addEventListener('click', this._handleClicked);
	}
	get number(){
		return this._siteJsonUnitPlot.number;
	}
	set filteredOut(value){
		if(value)
			this._element.classList.add('filtered-out');
		else
			this._element.classList.remove('filtered-out');
	}
	get element(){
		return this._element;
	}
	_handleClicked(){
		this._callbackClicked(this._siteJsonUnitPlot);
	}
}
